import StoryPlayerFactory from "../../engine/player/StoryPlayerFactory";

/**
 * The StoryFrameworkPlayerMemento represents (and abstracts away) the state of 
 * a StoryFrameworkPlayer according to the Memento pattern.
 * @param {type} storyPlayerMemento
 * @returns {StoryFrameworkPlayerMemento}
 * @constructor
 */
export default class StoryFrameworkPlayerMemento {
    constructor(storyPlayerMemento) {
        this._storyPlayerMemento = storyPlayerMemento;
    }

    /**
     * Serialize the StoryFrameworkPlayerMemento
     * @returns {unresolved}
     */
    serialize() {
        return this._storyPlayerMemento.serialize();
    }

    /**
     * Deserialize the StoryFrameworkPlayerMemento
     * @param {type} data
     * @returns {undefined}
     */
    deserialize(data) {
        this._storyPlayerMemento = StoryPlayerFactory.createStoryPlayerMemento();
        this._storyPlayerMemento.deserialize(data);
    }
}